export interface ContentCreationSubmission {
  id: string;
  submittedBy: string;
  submittedByName: string;
  submittedByEmail: string;
  title: string;
  caption: string;
  platform: SocialPlatform[];
  mediaFiles: string[];
  mediaType: 'image' | 'video' | 'carousel';
  thumbnailUrl?: string; // Custom thumbnail for videos or selected image for carousels
  promotedItems?: string[];
  status: ContentApprovalStatus;
  submittedAt: Date;
  updatedAt: Date;
  scheduledDate?: Date; // When the content should be published/scheduled
  reviewedBy?: string;
  reviewedByName?: string;
  reviewedAt?: Date;
  feedback?: string;
  approvalNotes?: string;
  rejectionReason?: string;
  reworkRequested?: boolean;
  originalSubmissionId?: string; // For tracking rework submissions
}

export type SocialPlatform = 
  | 'instagram' 
  | 'facebook' 
  | 'twitter' 
  | 'linkedin' 
  | 'tiktok' 
  | 'youtube' 
  | 'snapchat'
  | 'pinterest';

export type ContentApprovalStatus = 
  | 'submitted' 
  | 'under_review' 
  | 'approved' 
  | 'denied' 
  | 'rework_requested'
  | 'resubmitted';

export interface ContentCreationFormData {
  title: string;
  caption: string;
  platform: SocialPlatform[];
  mediaFiles: File[];
  thumbnailFile?: File; // Custom thumbnail file for videos
  selectedThumbnailIndex?: number; // Index of selected image for carousel thumbnails
  promotedItems: string;
}

export interface ContentReviewAction {
  action: 'approve' | 'deny' | 'request_rework';
  feedback?: string;
  approvalNotes?: string;
  rejectionReason?: string;
}

export const PLATFORM_OPTIONS: { value: SocialPlatform; label: string; icon: string }[] = [
  { value: 'instagram', label: 'Instagram', icon: '' },
  { value: 'facebook', label: 'Facebook', icon: '' },
  { value: 'twitter', label: 'Twitter', icon: '' },
  { value: 'linkedin', label: 'LinkedIn', icon: '' },
  { value: 'tiktok', label: 'TikTok', icon: '' },
  { value: 'youtube', label: 'YouTube', icon: '' },
  { value: 'snapchat', label: 'Snapchat', icon: '' },
  { value: 'pinterest', label: 'Pinterest', icon: '' },
];

export const STATUS_COLORS = {
  submitted: '#3B82F6',
  under_review: '#F59E0B',
  approved: '#10B981',
  denied: '#EF4444',
  rework_requested: '#8B5CF6',
  resubmitted: '#06B6D4',
} as const;

export const STATUS_LABELS = {
  submitted: 'Submitted',
  under_review: 'Under Review',
  approved: 'Approved',
  denied: 'Denied',
  rework_requested: 'Rework Requested',
  resubmitted: 'Resubmitted',
} as const; 